var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7C0E2FE4-91C2-4FFA-BE9E-945E69106CE5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "006-time-and-date",
    transform: "translate(-914.000000, -810.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(914.000000, 810.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2510638,1.45248227 L13.0723404,1.45248227 L13.0723404,0.726241135 C13.0723404,0.325149231 12.7471912,0 12.3460993,0 C11.9450074,0 11.6198582,0.325149231 11.6198582,0.726241135 L11.6198582,1.45248227 L8.71489362,1.45248227 L8.71489362,0.726241135 C8.71489362,0.325149231 8.38974439,0 7.98865248,0 C7.58756058,0 7.26241135,0.325149231 7.26241135,0.726241135 L7.26241135,1.45248227 L4.35744681,1.45248227 L4.35744681,0.726241135 C4.35744681,0.325149231 4.03229758,0 3.63120567,0 C3.23011377,0 2.90496454,0.325149231 2.90496454,0.726241135 L2.90496454,1.45248227 L0.726241135,1.45248227 C0.325149231,1.45248227 0,1.7776315 0,2.1787234 L0,15.2510638 C0,15.6521557 0.325149231,15.977305 0.726241135,15.977305 L15.2510638,15.977305 C15.6521557,15.977305 15.977305,15.6521557 15.977305,15.2510638 L15.977305,2.1787234 C15.977305,1.7776315 15.6521557,1.45248227 15.2510638,1.45248227 Z M1.45248227,2.90496454 L2.90496454,2.90496454 L2.90496454,3.63120567 C2.90496454,4.03229758 3.23011377,4.35744681 3.63120567,4.35744681 C4.03229758,4.35744681 4.35744681,4.03229758 4.35744681,3.63120567 L4.35744681,2.90496454 L7.26241135,2.90496454 L7.26241135,3.63120567 C7.26241135,4.03229758 7.58756058,4.35744681 7.98865248,4.35744681 C8.38974439,4.35744681 8.71489362,4.03229758 8.71489362,3.63120567 L8.71489362,2.90496454 L11.6198582,2.90496454 L11.6198582,3.63120567 C11.6198582,4.03229758 11.9450074,4.35744681 12.3460993,4.35744681 C12.7471912,4.35744681 13.0723404,4.03229758 13.0723404,3.63120567 L13.0723404,2.90496454 L14.5248227,2.90496454 L14.5248227,5.80992908 L1.45248227,5.80992908 L1.45248227,2.90496454 Z M1.45248227,14.5248227 L1.45248227,7.26241135 L14.5248227,7.26241135 L14.5248227,14.5248227 L1.45248227,14.5248227 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendarWhite.8c440a4efb1feb04e1a5b961591df8a8.svg";